import styled from 'styled-components';

import NavHeading from './NavHeading';

const StyledSlider = styled.div`
	align-items: center;
	display: grid;
	grid-gap: 1rem;
	grid-template: auto / auto 1fr auto;

	* {
		font-size: 14px;
	}

	input[type='range'] {
		width: 100%;
	}
`;

interface Props {
	year: number;
	setYear: (year: number) => void;
	startYear: number;
	endYear: number;
	area: string;
}

const YearSelect = ({ year, setYear, startYear, endYear, area }: Props) => {
	const years = Array.from(
		{ length: endYear - startYear + 1 },
		(_, i) => startYear + i,
	);
	return (
		<div style={{ gridArea: area }}>
			<NavHeading htmlFor="year-select">Select Year</NavHeading>
			<StyledSlider>
				<div>{startYear}</div>
				<input
					id="year-select"
					type="range"
					min={startYear}
					max={endYear}
					step="1"
					list="years"
					onChange={e => {
						setYear(+e.target.value);
					}}
				/>
				<div>{endYear}</div>
			</StyledSlider>
			<datalist id="years">
				{years.map(year => (
					<option
						key={`range-year-${year}`}
						value={year}
						label={year.toString()}
					></option>
				))}
			</datalist>
			<div
				style={{ textAlign: 'center', fontSize: '14px' }}
			>{`Current Year: ${year}`}</div>
		</div>
	);
};

export default YearSelect;
